export default () => {
  const showMoreString = 'Mehr lesen';
  const showLessString = 'Weniger lesen';

  const showMoreSelectorAttr = 'data-show-more-name';
  const showMoreSelector = '[data-show-more-name]';

  const showMoreButtonClassNameActive = 'button--show-more-active';
  const showMoreButtonSelector = `.button--show-more${showMoreSelector}`;
  const showMoreButtonArray = $(showMoreButtonSelector);

  console.log(showMoreButtonSelector);

  const showMoreDrawerSelector = `.product-card__text${showMoreSelector}`;
  const showMoreDrawerArray = $(showMoreDrawerSelector);

  showMoreButtonArray.each(function() {
    const showMoreButton = $(this);
    const showMoreButtonSelectorValue = showMoreButton.attr(showMoreSelectorAttr);
    const showMoreDrawerSelector = `[${showMoreSelectorAttr}="${showMoreButtonSelectorValue}"]`;
    const showMoreDrawer = showMoreDrawerArray.filter(showMoreDrawerSelector);

    showMoreButton.click(function() {
      const isTextHiding = showMoreButton.hasClass(showMoreButtonClassNameActive)
      const textToInsert = isTextHiding ? showMoreString : showLessString;
      const scrollUpPixelAfterClosingDrawer = 400;

      if (isTextHiding) {
        $('html, body').animate({
          scrollTop: showMoreDrawer.offset().top - scrollUpPixelAfterClosingDrawer
        }, 500);
      }

      showMoreButton.text(textToInsert);
      showMoreButton.toggleClass(showMoreButtonClassNameActive);
      showMoreDrawer.slideToggle();
    });
  });

  const mq = window.matchMedia( "(min-width: 1150px)" );

  const WidthChange = (mq) => {

    if (mq.matches) {

      // $('.product-card__packshot').removeClass('product-card__packshot--hide');
      $(showMoreButtonSelector).text(showMoreString);

      $('.product-card__text').css({
        display: ""
      });
    } 
  }

  mq.addListener(WidthChange);
  WidthChange(mq);
};
